import Swiper from "swiper/bundle";
// import "./_slider-gallery.scss";

document.addEventListener("DOMContentLoaded", () => {
  const SliderGallery = document.querySelectorAll(".slider-gallery");
  SliderGallery.forEach((slider) => {
    new Swiper(slider, {
      loop: true,
      spaceBetween: 20,
      slidesPerView: 1.2,
      keyboard: {
        enabled: true,
      },
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      speed: 1000,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: false,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  });
});
